import request from '@service/request';
import config from '@config';

export const fetchAll = () => request.get(config.apiURL + '/players');
